'use strict';
// GENERATED by build/stamp-version.js at build time. Do not edit; gitignored.
module.exports = {
	"Version": "1.0.1",
	"Commit": "082ca34",
	"BuildDate": "2026-10-30"
};
